import { render, staticRenderFns } from "./MarcaShowData.vue?vue&type=template&id=34b21a18&"
import script from "./MarcaShowData.vue?vue&type=script&lang=js&"
export * from "./MarcaShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports